<template>
  <component
    :is="is ?? 'div'"
    :class="[
      'group relative flex h-10 w-full items-center rounded-lg transition-colors hover:bg-gray-100 hover:shadow-sm md:justify-between',
      unresponsive ? 'justify-between px-4' : 'justify-center sm:px-4',
      isActive ? 'bg-gray-100 text-gray-600 shadow-sm' : 'text-gray-500'
    ]"
    @click="tab.handler?.(tab, index)"
  >
    <div
      :class="[
        'absolute h-full w-full xl:hidden',
        unresponsive ? 'hidden' : ''
      ]"
    >
      <Tippy
        class="h-full w-full"
        :content="tab.title"
        placement="right"
      ></Tippy>
    </div>
    <div
      :class="[
        'flex max-w-full items-center gap-x-3 md:justify-start',
        unresponsive ? '' : 'justify-center'
      ]"
    >
      <slot name="icon" :="{ tab }">
        <Icon
          v-if="tab.icon"
          :name="tab.icon"
          :class="[
            'size-5 min-w-5 transition-transform',
            tab.iconClass
              ? tab.iconClass
              : isActive
                ? 'scale-110 text-gray-900'
                : ''
          ]"
        />
      </slot>
      <div
        :class="[
          'truncate text-xs md:inline-block',
          unresponsive ? '' : 'hidden'
        ]"
      >
        {{ tab.title }}
      </div>
    </div>
    <Icon
      v-if="tab.altIcon"
      :name="tab.altIcon"
      :class="['size-3 min-w-3 transition-transform', tab.altIconClass]"
    />
    <NavBadge
      v-if="tab.badge"
      :="{ badge: tab.badge, isActive }"
      class="group-hover:bg-gray-800 group-hover:text-white"
    />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  tab: NavItem
  index: number
  isActive: boolean
  unresponsive?: boolean
  is?: keyof HTMLElementTagNameMap
}>()
</script>
